import React from 'react';
import { useEffect, useState } from 'react';
import SkeletonCard from '../../Assetes/SkeletonLoader/SkeletonCard';
import ManuCard from './TopDealCard'
import useTrackEvent from '../../hooks/useTrackHook';
import { useTranslation } from 'react-i18next';


function TopDeals(props: any) {
  const [isMobile, setIsMobile] = useState(false);
  const [addEvent] = useTrackEvent();
  const { t } = useTranslation();
  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    handleWindowSizeChange();

    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return (
    <>
      {props.topDeals ? (
        <>
          {props.topDeals && props.topDeals.length > 0 ? (
            <div className="container mb-5">
              <h2 className="items-title">
                <span> {t("TOPDEALS")}</span>
              </h2>
              <div className={isMobile ? "borws-row" : "row"}>
                {props.topDeals && props.topDeals.length > 0 ? (
                  props.topDeals.map((item: any, index: any) => {
                    return (
                      <div
                        onClick={() =>
                          addEvent({
                            category: "events",
                            events: `view top deal ${item.combo_name}`,
                          })
                        }
                        key={index}
                        className="col-lg-3 col-md-4 col-6 "
                      >
                        <ManuCard
                          item={item}
                          selectedItem={props.selectedItem}
                          handleAdd={props.handleAdd}
                        />
                      </div>
                    );
                  })
                ) : (
                  <div />
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      ) :
        <SkeletonCard />
      }
    </>
  );
}
export default TopDeals;
